import React from "react"
import PropTypes from "prop-types"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import TextField from "material-ui/TextField"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import AccountStore from "../../../stores/AccountStore"
const utils = require("../../../helpers/utils")

const propTypes = {
    open: PropTypes.bool,
    editRole: PropTypes.object,
    handleClose: PropTypes.func,
    handleSave: PropTypes.func
}

class AddAccountRoleDialog extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            type: props.editRole ? props.editRole.Type : "",
            typeErrorText: ""
        }
        this.canCheckValidate = false
        autobind(this)
    }

    handleSave() {
        this.canCheckValidate = true
        if (this.checkValidate()) {
            const role = {
                Id: this.props.editRole ? this.props.editRole.Id : utils.guid(),
                Type: this.state.type.trim(),
                Permissions: this.props.editRole ? this.props.editRole.Permissions : []
            }
            this.props.handleSave(role)
        }
    }

    checkValidate() {
        const type = this.state.type.trim()
        let typeErrorText
        if (type.length === 0) {
            typeErrorText = strings.This_field_is_required
        } else if (AccountStore.getCurrentAccountSettings().UserRoles.filter((role) => role.Type === type).length > 0) {
            typeErrorText = strings.User_role_name_is_duplicated
        } else {
            typeErrorText = ""
        }
        this.setState({ typeErrorText })
        return typeErrorText === ""
    }

    handleChangeType(e) {
        this.setState(
            {
                type: e.target.value
            },
            () => {
                this.canCheckValidate && this.checkValidate()
            }
        )
    }

    render() {
        const actions = [<FlatButton data-intercom-target={"menu-AccountUsers-Roles-Btn-CloseAddAccountRoleDialog"} label={strings.CANCEL} primary={false} onClick={this.props.handleClose} />, <FlatButton data-intercom-target={"menu-AccountUsers-Roles-Btn-SaveAccountRole"} label={strings.SAVE} primary keyboardFocused onClick={this.handleSave} />]
        return (
            <Dialog
                title={this.props.editRole ? strings.Edit_Account_Role_Type : strings.Add_Account_Role_Type}
                actions={actions}
                modal={false}
                open={this.props.open}
                onRequestClose={this.props.handleClose}
            >
                <TextField
                    data-intercom-target={"menu-AccountUsers-Roles-Add-Entry-RoleType"}
                    autoFocus
                    floatingLabelText={strings.Role_Type}
                    value={this.state.type}
                    onChange={this.handleChangeType}
                    errorText={this.state.typeErrorText}
                    errorStyle={{ position: "absolute", bottom: -10 }}
                />
            </Dialog>
        )
    }
}

AddAccountRoleDialog.propTypes = propTypes
export default AddAccountRoleDialog
